// ─── Runtime environment config ──────────────────────────────────────────────
// Single source of truth for reading configuration that must be settable per
// environment WITHOUT rebuilding the image.
//
// CRA inlines `process.env.REACT_APP_*` at BUILD time, so values baked into the
// bundle can't change between dev/prod. To keep one promotable image, the
// container regenerates `window.__RUNTIME_CONFIG__` from its own env vars on
// startup (see ui/docker-entrypoint.d/40-env-config.sh). We therefore read the
// runtime config FIRST, then fall back to the build-time value (.env.local for
// local `npm start`), then to an optional default.
//
// Whenever you add a key here, also emit it from the entrypoint script and list
// it (empty) in public/env-config.js so local dev keeps working.

type RuntimeConfig = Record<string, string | undefined>;

const runtimeConfig: RuntimeConfig =
  (typeof window !== 'undefined' && (window as any).__RUNTIME_CONFIG__) || {};

/**
 * Read a REACT_APP_* setting, preferring the container's runtime config over the
 * build-time inlined value. Returns `fallback` (default '') when unset.
 */
export function getRuntimeEnv(key: string, fallback = ''): string {
  return runtimeConfig[key] || process.env[key] || fallback;
}
